//--------------------------------- App Settings ---------------------------------//

const APP_PROVIDER = "iOrders";

const APP_ACCOUNT = "Rethink Bioclean";

const DEFAULT_APP_INDEX_PAGE_PATH = "/inventory/products";

export { APP_PROVIDER, APP_ACCOUNT, DEFAULT_APP_INDEX_PAGE_PATH };
